import React from 'react';
import './footer.scss';
import { Link as ScrollLink, scroller} from "react-scroll";
import {useTranslation} from "react-i18next";
import QuickLinks from "../quick_links/quick_links";


const Footer = ({ props }: {
    props: {
        menuOpen: boolean;
        legalInformation: boolean,
        setLegalInformation: (legalInformation: boolean) => void
    }
}) => {
    const {t} = useTranslation()


    const handleLegalClick = () => {
        props.setLegalInformation(!props.legalInformation);
        setTimeout(() => {
            scroller.scrollTo("legal", {
                smooth: true,
                duration: 500,
                offset: 0,
            });
        }, 0);
    };
    return (
        <footer className={"footer"}>
            <div className={"bottom"}>
                <ScrollLink to='home'
                            offset={-250}
                            className={"link-default"}
                            onClick={() => props.setLegalInformation(false)}>
                    {t("footer.footerAddress")}
                </ScrollLink>
                <ScrollLink to={'legal'}
                            offset={-250}
                            className={"link-default"}
                            onClick={handleLegalClick}>
                    {props.legalInformation ? t("footer.hideLegalInformation"): t("footer.displayLegalInformation")}
                </ScrollLink>
            </div>
            {!props.menuOpen && (<QuickLinks/>)}
        </footer>
    );
};

export default Footer;
